import React, {Component} from 'react';
import './ProfileCompany.css';

class ProfileCompany extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <form className="p-x-1">
                <button type="submit" className="btn btn-lg btn-primary m-t-3">Обновить данные компании</button>
            </form>
        );
    }
}

export default ProfileCompany;


// WEBPACK FOOTER //
// ./src/pages/Profile/Company/ProfileCompany.js